import CollectionDetailPage from '../CollectionDetailPage';
export default function BedroomPage() { return <CollectionDetailPage collectionId="bedroom" />; }
